import { render, staticRenderFns } from "./VisitHistoryItem.vue?vue&type=template&id=a553499e&"
import script from "./VisitHistoryItem.vue?vue&type=script&lang=js&"
export * from "./VisitHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./VisitHistoryItem.vue?vue&type=style&index=0&id=a553499e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports